export default "__VITE_ASSET__DVzhnEjo__"